import { NETWORK_ACTION, NETWORK_PATH } from '../../constants'
import getRequestsNetworkSelect from '../../selectors/get-requests'
import addRequestNetworkUtil from '../../utils/add-request'
import setReduxAction from '../../../redux/actions/set'
// import { logUtil } from 'packages/src'
//
//

function addRequestNetworkAction (action) {
  return (dispatch, getState) => {
    // logUtil('').debug('requests: ', getRequestsNetworkSelect(getState()))
    const state = addRequestNetworkUtil({
      action,
      state: getState()
    })

    // logUtil('').debug('newRequests: ', getRequestsNetworkSelect(state))
    dispatch(setReduxAction({
      type: NETWORK_ACTION.ADD_REQUEST,
      payload: {
        path: NETWORK_PATH.REQUESTS,
        value: getRequestsNetworkSelect(state)
      }
    }))
  }
}

export default addRequestNetworkAction
